import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, OnDestroy, Renderer2 } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ThemeLoaderService implements OnDestroy {
 private style?: HTMLLinkElement;
 private renderer2 ?: Renderer2;
  constructor(@Inject(DOCUMENT) private document: Document) { 
  }

  ngOnDestroy(): void {
     this.renderer2?.removeChild(this.document.head, this.style);
  }


  public loadTheme(renderer2: Renderer2): void {
      if (renderer2) {
        this.renderer2 = renderer2;
      }
      if (this.renderer2) {
        let hostname = window.location.hostname.toLocaleLowerCase();
        const port = window.location.port;
        if (hostname == 'localhost' && port) {
          hostname = `${hostname}:${port}`;
        }
        const href = this.resolveTheme(hostname);
        if (href) {
          this.setStylesheet(href);
        }
      }
  }

  private resolveTheme(hostname: string) : string | undefined {
      const themes = environment.themes;
      for (const [pattern,href] of Object.entries(themes)) {
        if (hostname.endsWith(pattern)) {
          return href;
        }
      }
      return undefined;
  } 
  
  private setStylesheet(cssPath:string) {
    if (this.renderer2) {
      const id = 'hostname-theme';
      this.style = this.document.getElementById(id) as HTMLLinkElement;
      if (!this.style) {
        this.style = this.renderer2.createElement('link') as HTMLLinkElement;
        this.style.id = id;
        this.style.rel = 'stylesheet';
        this.style.type = "text/css";
        this.renderer2.appendChild(this.document.head,  this.style);
      }
      this.renderer2.setProperty(this.style, 'href', cssPath);
    }
  }

  
}

